import { render } from "./FloatingCoffeeButton.vue?vue&type=template&id=9883abc2&scoped=true"
import script from "./FloatingCoffeeButton.vue?vue&type=script&lang=js"
export * from "./FloatingCoffeeButton.vue?vue&type=script&lang=js"

import "./FloatingCoffeeButton.vue?vue&type=style&index=0&id=9883abc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9883abc2"]])

export default __exports__